import Dexie, { type Table } from "dexie";

export interface CachedAttendee {
	attendeeId: string;
	firstName: string | null;
	lastName: string | null;
	email: string | null;
	ticketId: string | null;
	registrationTypeId: string | null;
	confirmationCode: string | null;
	search: string;
}

export interface LocalCheckIn {
	clientId: string;
	attendeeId: string;
	direction: "in" | "out";
	voidsClientId: string | null;
	occurredAt: string;
	createdAt: string;
	source: "scan" | "search" | "kiosk" | "manual";
	synced: 0 | 1;
	claimedName?: string | null;
	claimedEmail?: string | null;
}

export interface SyncMeta {
	key: string;
	value: string;
}

export class CheckinDB extends Dexie {
	attendees!: Table<CachedAttendee, string>;
	checkIns!: Table<LocalCheckIn, string>;
	meta!: Table<SyncMeta, string>;

	constructor(eventId: string) {
		super(`sunfish-checkin-${eventId}`);
		this.version(1).stores({
			attendees: "attendeeId, search",
			checkIns: "clientId, attendeeId, synced",
			meta: "key",
		});
		this.version(2).stores({
			attendees: "attendeeId, search, confirmationCode",
		});
	}
}

let instance: CheckinDB | null = null;

export function getDb(eventId: string): CheckinDB {
	if (!instance || instance.name !== `sunfish-checkin-${eventId}`) {
		instance = new CheckinDB(eventId);
	}
	return instance;
}
